import React from 'react';
import { View, FlatList, RefreshControl, Text } from 'react-native';
import { connect } from 'react-redux';

import Colors from "../../constants/Colors";
import {CardTextArrow, Spacing, SpinnerControl} from "../../components";
import get from "../../api/methods/get";
import {QUERY_DELIVERABLES_BY_USER} from "./api/deliveryEndpoints";
import PlayerDeliverableComponent from "./PlayerDeliverableComponent";
import NavBar from "../../components/NavBar";

class PlayerDeliveryScreen extends React.Component {

    state = {
        isFetching: false,
        deliverables: []
    }

    fetchDeliverables = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true })

        try {

            let result = await get(QUERY_DELIVERABLES_BY_USER(this.props.userId, this.props.currentJourney.id));
            let json = await result.json();

            this.setState({ deliverables: json.data.Items });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false })
    }

    componentDidMount() {
        this.fetchDeliverables();
    }

    render() {

        return (
            <NavBar title={"Minhas Aplicações"}>

                <View style={{ width: 600, }}>
                    <CardTextArrow
                        text={"Enviar uma nova aplicação"}
                        showArrow={true}
                        onPress={() => this.props.history.push('/applications/userApplications/composer')}
                        containerStyle={{ marginBottom: 20, backgroundColor: Colors.tabBarNavigationBackground }}
                    />

                    <SpinnerControl
                        isFetching={this.state.isFetching}
                        text={"Carregando!"}
                    />

                    {
                        (this.state.isFetching === false && this.state.deliverables.length === 0) &&
                            <Text style={{ color: Colors.fontColorOnBackground, fontSize: 18, textAlign: 'center' }}>
                                Você ainda não fez nenhum envio!
                            </Text>
                    }

                    <Spacing height={22} />


                    <FlatList
                        contentContainerStyle={{ width: 600 }}
                        data={this.state.deliverables}
                        renderItem={({item}) => {
                            return <PlayerDeliverableComponent {...item} />
                        }}
                        keyExtractor={item => item.SK.toString()}
                        refreshControl={
                            <RefreshControl
                                refreshing={this.state.isFetching}
                                onRefresh={() => this.fetchDeliverables()}
                                colors={[Colors.spinnerColor]}
                                title={'Carregando entregas!'}
                            />
                        }
                    />
                </View>

            </NavBar>
        )
    }

}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        currentJourney: state.journey.currentJourney,
    }
}

export default connect(mapStateToProps)(PlayerDeliveryScreen);
